module.exports = __webpack_public_path__ + "static/desdeMalta-2c45fe7bceff9393687e180a50254fb1.png";